<template>
  <v-flex
    xs12
    sm6
    md12>
    <v-layout row>
      <v-flex
        xs12
        sm6
        md6>

        <v-label>{{ 'krita.reports.factorings.filter.labeldue' | translate }}</v-label> <!--Factoring due date between dates-->

        <v-menu
          ref="factoringsDueFromMenu"
          v-model="factoringsDueFromMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          :return-value.sync="factoringsDueFromDate"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="factoringsDueFromDate"
              :label="datePickerLabelStart"
              prepend-icon="event"
              readonly
              clearable
              v-on="on"
              @click:clear="clearDate('dueFromDate')"
            />
          </template>
          <v-date-picker
            v-model="factoringsDueFromDate"
            no-title
            scrollable>
            <v-spacer/>
            <v-btn
              flat
              color="primary"
              @click="factoringsDueFromMenu = false">{{ 'krita.cancel' | translate }}</v-btn>
            <v-btn
              class="primary"
              color="primary"
              @click="filterFactoringsDueFrom">{{ 'krita.ok' | translate }}</v-btn>
          </v-date-picker>
        </v-menu>

        <v-menu
          ref="factoringsDueToMenu"
          v-model="factoringsDueToMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          :return-value.sync="factoringsDueToDate"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="factoringsDueToDate"
              :label="datePickerLabelEnd"
              prepend-icon="event"
              clearable
              v-on="on"
              @click:clear="clearDate('dueToDate')"
            />
          </template>
          <v-date-picker
            v-model="factoringsDueToDate"
            no-title
            scrollable
            color = "primary">
            <v-spacer/>
            <v-btn
              flat
              color="primary"
              @click="factoringsDueToMenu = false">{{ 'krita.cancel' | translate }}</v-btn>
            <v-btn
              color="primary"
              class="primary"
              @click="filterFactoringsDueTo">{{ 'krita.ok' | translate }}</v-btn>
          </v-date-picker>
        </v-menu>

      </v-flex>

      <v-flex
        xs12
        sm6
        md6>

        <v-label>{{ 'krita.reports.factorings.filter.labelcreated' | translate }}</v-label> <!--Factoring created between dates-->

        <v-menu
          ref="factoringsCreatedFromMenu"
          v-model="factoringsCreatedFromMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          :return-value.sync="factoringsCreatedFromDate"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="factoringsCreatedFromDate"
              :label="datePickerLabelStart"
              prepend-icon="event"
              readonly
              clearable
              v-on="on"
              @click:clear="clearDate('createdFromDate')"
            />
          </template>
          <v-date-picker
            v-model="factoringsCreatedFromDate"
            no-title
            scrollable>
            <v-spacer/>
            <v-btn
              flat
              color="primary"
              @click="factoringsCreatedFromMenu = false">{{ 'krita.cancel' | translate }}</v-btn>
            <v-btn
              class="primary"
              color="primary"
              @click="filterFactoringsCreatedFrom">{{ 'krita.ok' | translate }}</v-btn>
          </v-date-picker>
        </v-menu>

        <v-menu
          ref="factoringsCreatedToMenu"
          v-model="factoringsCreatedToMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          :return-value.sync="factoringsCreatedToDate"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="factoringsCreatedToDate"
              :label="datePickerLabelEnd"
              prepend-icon="event"
              readonly
              clearable
              v-on="on"
              @click:clear="clearDate('createdToDate')"
            />
          </template>
          <v-date-picker
            v-model="factoringsCreatedToDate"
            no-title
            scrollable
            color = "primary">
            <v-spacer/>
            <v-btn
              flat
              color="primary"
              @click="factoringsCreatedToMenu = false">{{ 'krita.cancel' | translate }}</v-btn>
            <v-btn
              color="primary"
              class="primary"
              @click="filterFactoringsCreatedTo">{{ 'krita.ok' | translate }}</v-btn>
          </v-date-picker>
        </v-menu>
      </v-flex>
    </v-layout>

    <!--<div id="factoringsFilter">-->
    <!--<v-btn-->
    <!--:class="{ secondary: factoringsSelection === 'unpaid' }"-->
    <!--selection="unpaid"-->
    <!--color="#3357A0"-->
    <!--@click="$emit('filterFactorings','unpaid')">{{ 'krita.reports.factorings.filter.unpaid' | translate }}</v-btn>-->
    <!--<v-btn-->
    <!--:class="{ secondary: factoringsSelection === 'pastDue' }"-->
    <!--selection="pastDueDate"-->
    <!--color="#3357A0"-->
    <!--@click="$emit('filterFactorings','pastDue')">{{ 'krita.reports.factorings.filter.pastduedate' | translate }}</v-btn>-->
    <!--<v-btn-->
    <!--:class="{ secondary: factoringsSelection === 'repaid' }"-->
    <!--selection="repaid"-->
    <!--color="#3357A0"-->
    <!--@click="$emit('filterFactorings','repaid')">{{ 'krita.reports.factorings.filter.repaid' | translate }}</v-btn>-->
    <!--<v-btn-->
    <!--:class="{ secondary: factoringsSelection === 'all' }"-->
    <!--selection="all"-->
    <!--color="#3357A0"-->
    <!--@click="$emit('filterFactorings','all')">{{ 'krita.reports.factorings.filter.all' | translate }}</v-btn>-->
    <!--</div>-->

  </v-flex>
</template>

<script>
    export default {
        name: "FactoringsControllersVue",
        props: ['factoringsSelection'],
        data ()
        {
            return {
                datePickerLabelStart: this.$t('krita.datepick.startdate'),
                datePickerLabelEnd: this.$t('krita.datepick.enddate'),

                factoringsDueFromMenu: false,
                factoringsDueFromDate: null,
                factoringsDueToMenu: false,
                factoringsDueToDate: null,

                factoringsCreatedFromMenu: false,
                factoringsCreatedFromDate: null,
                factoringsCreatedToMenu: false,
                factoringsCreatedToDate: null,
            }
        },
        methods: {
            clearDate(target)
            {
                let self = this;

                switch (target) {
                    case 'dueFromDate':
                        self.factoringsDueFromDate = null;
                        break;
                    case 'dueToDate':
                        self.factoringsDueToDate = null;
                        break;
                    case 'createdFromDate':
                        self.factoringsCreatedFromDate = null;
                        break;
                    case 'createdToDate':
                        self.factoringsCreatedToDate = null;
                        break;
                }
                self.$emit('clearDate', target);
            },
            filterFactoringsDueFrom()
            {
                let self = this;
                self.$refs.factoringsDueFromMenu.save(self.factoringsDueFromDate);
                self.factoringsDueFromMenu = false;
                self.$emit('filterFactoringsDueFrom', self.factoringsDueFromDate)
            },
            filterFactoringsDueTo()
            {
                let self = this;
                self.$refs.factoringsDueToMenu.save(self.factoringsDueToDate);
                self.factoringsDueToMenu = false;
                self.$emit('filterFactoringsDueTo', self.factoringsDueToDate)
            },
            filterFactoringsCreatedFrom()
            {
                let self = this;
                self.$refs.factoringsCreatedFromMenu.save(self.factoringsCreatedFromDate);
                self.factoringsCreatedFromMenu = false;
                self.$emit('filterFactoringsCreatedFrom', self.factoringsCreatedFromDate)
            },
            filterFactoringsCreatedTo()
            {
                let self = this;
                self.$refs.factoringsCreatedToMenu.save(self.factoringsCreatedToDate);
                self.factoringsCreatedToMenu = false;
                self.$emit('filterFactoringsCreatedTo', self.factoringsCreatedToDate)
            },
        }
    }
</script>

<style scoped>

</style>
